<template>
    <div class="wxbind">
        <div v-if="status==1" class="status1">
            <img style="width: 124px;height: 135px;" src="../assets/image/wxbind/default_img2@2x.png" alt="">
            <p>您还未在PC端完成注册，<br/>先去注册吧~</p>
        </div>
        <div v-if="status==2" class="status3">
            <div class="status_bg">
                <img src="../assets/image/wxbind/logo@2x.png" alt="">
                <p><img src="../assets/image/wxbind/account_icon@2x.png" alt=""> 账号绑定</p>
            </div>
            <div class="status_input">
                <input type="text" class="user3" placeholder="输入账号" v-model="username">
                <input type="password" class="pwd3" placeholder="输入密码" v-model="password">
                <div class="button3" @click="login">确定</div>
            </div>
        </div>
        <div v-if="status==3" class="status1">
            <img style="width: 175px;height: 144px;" src="../assets/image/wxbind/default_img@2x.png" alt="">
            <p>您已绑定过~</p>
        </div>
        <p v-if="status==4" class="status1">绑定完成，请到pc端登录~</p>
        <!-- <p>{{code}}</p> -->
        
    </div>
</template>
<script>
export default {
    data(){
        return {
            status:2,
            code:null,
            username:null,
            password:null
        }
    },
    created(){
        // this.code = this.getQueryString('code')
        this.status = this.$store.state.status
                // 1 未注册 2 已注册 3已绑定
        // this.code = this.$store.state.unionid
    },
    methods:{
        login(){
            let that = this
            // alert(111)
            if(this.username&&this.password){
                that.$api.post('/bind_customer',{
                    unionid: this.$store.state.unionid,
                    username: this.username,
                    password: this.password
                })
                .then(function(res){
                    // console.log(res)
                    // alert(res.data.status_code)
                    // alert(res.data.msg)
                    if(res.data.status_code == 200){
                        that.status = 4
                        that.$store.commit('setstatus', 3)
                    }
                })
                .catch(function(err){
                    alert(err)
                })
            }
        },
        getQueryString(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if(r != null) return unescape(r[2]);
            return null;

        }
    }
}
</script>
<style scoped>
.wxbind{
    width: 100%;
    height: 100%;
    background:#fff;
    position: relative;
    color: #666;
}
.status1{
    width: fit-content;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.status1 img{
    display: block;
    margin: 0 auto;
}
.status1 p{
    text-align: center;
    margin-top: 20px;
}
.status3{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: relative;
}
.status_bg{
    width: 100%;
    height: 32%;
    background: url('../assets/image/wxbind/background@2x.png') center center;
    background-size: cover;
}
.status_bg>img{
    width: 154px;
    height: 21px;
    margin-top: 22px;
    margin-left: 16px;
}
.status3 p{
    width: 100%;
    color: #fff;
    font-size: 28px;
    margin-top: 44px;
    margin-left: 15px;
    font-family:AlibabaPuHuiTiB;
}
.status3 p>img{
    width: 44px;
    height: 44px;
    vertical-align: bottom;
}
.status_input{
    width: calc(100% - 30px);
    height: 280px;
    background: #fff;
    /* border: 1px solid red; */
    border-radius: 16px;
    position: absolute;
    top: 24%;
    left: 15px;
}
.status3 input{
    width: 73%;
    height: 54px;
    display: block;
    margin: 0 auto;
    border: none;
    border-bottom: 1px solid #eaeaea;
    text-indent: 2px;
}
.status3 input::placeholder{
    color: #999;
}
.status3 .user3{
    margin-top: 1rem;
}
.status3 .pwd3{
    margin-bottom: 40px;
}
.status3 .button3{
    width: 73%;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
    border-radius:50px;
    border: none; 
    text-align: center;
    background: #DA5235;
    color: #fff;
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/wxbind.vue